import {isAnyOf} from '@reduxjs/toolkit';

import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

import {isEmpty} from '#core/utils/config-utils.js';

const reduxInstance = MojitoCore.Services.redux;
const {dispatch} = MojitoCore.Services.redux.store;

const {actions: UserInfoActions, selectors: UserInfoSelectors} = MojitoServices.UserInfo;
const {actions: AuthenticationActions, selectors: AuthenticationSelectors} = MojitoServices.Authentication;
const {actions: BootstrapActions} = MojitoServices.Bootstrap;

//------------------------------------------------------------------------------

/*
Sometimes, Portal provides the balances update (OAPI_RESPONSE) before Sportsbook/Lotto is logged in.
This is a problem when Sportsbook/Lotto fully relies on IMS balances update (useIMSFreebetBalance: true), because:
 1) On loginSuccess, Sportsbook/Lotto takes the balances from userInfo.balances;
 2) userInfo.balances does not contain the freebet balance.
As the result, Sportsbook/Lotto overrides the balances from OAPI_RESPONSE with userInfo.balances, missing the freebet balance.
To prevent this, DBX stores the balances from OAPI_RESPONSE as pendingBalancesToMojito, and passes it into Sportsbook/Lotto on loginSuccess.
 */

let pendingBalances = {};

reduxInstance.actionListener.startListening({
    actionCreator: AuthenticationActions.loginSuccess,
    effect: action => {
        if (!isEmpty(pendingBalances)) {
            dispatch(UserInfoActions.updateBalance({...pendingBalances, ...action.payload?.userInfo?.balances}));
            pendingBalances = {};
        }
    },
});

reduxInstance.actionListener.startListening({
    matcher: isAnyOf(BootstrapActions.dispose, AuthenticationActions.disposeSession),
    effect: () => {
        pendingBalances = {};
    },
});

//------------------------------------------------------------------------------

export function updateBalancesInMojFormat(balances) {
    if (AuthenticationSelectors.isLoggedIn()) {
        const userInfo = UserInfoSelectors.selectUserInfo();
        if (userInfo && userInfo.balances) {
            const {balances: currentBalances} = userInfo;
            const newBalances = {...currentBalances, ...balances};
            dispatch(UserInfoActions.updateBalance(newBalances));
        }
    } else {
        // Just postpone the balances until loginSuccess
        pendingBalances = {...pendingBalances, ...balances};
    }
}
